<template>
    <div id="dialog1">
        <el-button class="deleUp" type="text" @click="dialogFormVisible = true">修改密码</el-button>

        <el-dialog title="修改密码" class="title" :visible.sync="dialogFormVisible">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <p class="ApoTitle">旧密码</p>
                <el-form-item prop="pass">
                    <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
                </el-form-item>
                <p class="ApoTitle">新密码</p>
                <el-form-item prop="password">
                    <el-input type="password" v-model="ruleForm.password"></el-input>
                </el-form-item>
                <p class="ApoTitle">确认新密码</p>
                <el-form-item prop="affirm">
                    <el-input type="password" v-model="ruleForm.affirm"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="Chzhi" @click="Chzhi">重置</el-button>
                <el-button class="and" type="primary" @click="formclick('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import {
        EnterpriseBackground
    } from "../../../api/backstageManagement";
    export default {
        data() {
            var validatePass1 = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("新密码不能为空"));
                } else if (value == this.ruleForm.pass) {
                    callback(new Error("新密码和旧密码不能相同!"));
                } else {

                    var ls = 0;
                    if (this.ruleForm.password.match(/([a-z])+/)) {
                        ls++;
                    }
                    if (this.ruleForm.password.match(/([0-9])+/)) {
                        ls++;
                    }
                    if (this.ruleForm.password.match(/([A-Z])+/)) {
                        ls++;
                    }
                    if (
                        this.ruleForm.password.match(/([\W])+/) &&
                        !this.ruleForm.password.match(/(![\u4E00-\u9FA5])+/)
                    ) {
                        ls++;
                    }
                    if (
                        this.ruleForm.password.length < 6 ||
                        this.ruleForm.password.length > 18
                    ) {

                        callback(new Error("要求6-18位字符"));
                        ls = 0;
                    }

                    if (this.ruleForm.password.match(/([\u4E00-\u9FA5])+/)) {
                        callback(new Error("不能包含中文字符"));
                        ls = 0;
                    }

                    switch (ls) {
                        case 0:

                            callback(
                                new Error("密码必须大小写、数字、特殊符号两种或两种以上！")
                            );
                            break;
                        case 1:


                            callback(
                                new Error("密码必须大小写、数字、特殊符号两种或两种以上！")
                            );

                            break;
                        case 2:

                            callback();
                            break;
                        case 3:
                            callback();
                            break;
                            // case 4:
                            // default:
                            //   this.percentage = 0;
                            //   break;
                    }

                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === "" || value.trim() === "") {
                    callback(new Error("请再次输入新密码"));
                } else if (value !== this.ruleForm.password) {
                    callback(new Error("两次输入密码不一致!"));
                } else {
                    callback();
                }
            };
            return {
                dialogFormVisible: false,
                //修改
                ruleForm: {
                    pass: "",
                    password: "",
                    affirm: "",
                },

                rules: {
                    pass: [{
                            required: true,
                            message: "旧密码不可为空",
                            trigger: "blur"
                        },
                        {
                            min: 6,
                            max: 18,
                            message: "长度在 6 到 18  个字符",
                            trigger: "blur",
                        },
                    ],
                    password: [{
                        validator: validatePass1,
                        trigger: "blur"
                    }],
                    affirm: [{
                        validator: validatePass2,
                        trigger: "blur"
                    }],
                },
            };
        },
        methods: {
            Chzhi() {
                this.ruleForm.password = "";
                this.ruleForm.pass = "";
                this.ruleForm.affirm = "";
            },
            formclick(formName) {
                // console.log(this.$store.state.homeitem.user)
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        let user = this.$store.state.homeitem.user.firmAccount;
                        // console.log(user);

                        EnterpriseBackground.userpass(
                            user,
                            this.ruleForm.password,
                            this.ruleForm.pass
                        ).then((res) => {
                            if (res.data.status) {
                                this.dialogFormVisible = false;
                                this.$message({
                                    message: "密码修改成功",
                                    type: "success",
                                });
                                this.ruleForm.password = "";
                                this.ruleForm.pass = "";
                                this.ruleForm.affirm = "";
                            } else {
                                this.$message.error("旧密码输入不正确")
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
        },
    };
</script>
<style scoped lang="less">
    .ApoTitle {
        color: #666666;
        font-size: 16px;
        font-weight: 400;
    }

    .Chzhi {
        width: 60px;
        height: 32px;
        font-size: 14px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        /* margin: 0 !important; */
    }

    .and {
        width: 60px;
        height: 32px;
        font-size: 14px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        /* margin: 0 !important; */
    }

    .dialog-footer {
        margin-top: 25px;
        height: 32px;
        font-size: 14px;
        display: flex;

        .el-button--default {
            line-height: 8px;
        }

        .el-button--primary {
            line-height: 8px;
        }
    }

    .deleUp:focus,
    .deleUp:hover {
        color: #36abff;
    }

    .deleUp {
        color: #0d94ff;
        padding: 0;
    }
</style>